import { useManifestViewsV2 } from "hooks/useManifestViewsV2";

import { Manifests as ManifestsV1 } from "./ManifestsV1";
import { ManifestsV3 } from "./ManifestsV3";

/**
 * Routes the Manifests page to the mixed manifests/bills-of-lading view when
 * `manifest-views-v2` is enabled for the tenant, and to the v1 view otherwise.
 */
export function ManifestsView() {
  const showManifestViewsV2 = useManifestViewsV2();
  return showManifestViewsV2 ? <ManifestsV3 /> : <ManifestsV1 />;
}
